"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePropBlock = decodePropBlock;
exports.findProp = findProp;
exports.findPropValue = findPropValue;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const entity_list_1 = require("./entity-list");
function decodePropBlock(node, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        return null;
    }
    const detected = (0, entity_list_1.detectEntityList)(node.children);
    if (detected === null) {
        return null;
    }
    if (detected.typeCode !== '40' && detected.typeCode !== '37') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnknownTypeCode,
            message: `expected prop block typeCode=40 or 37, found ${detected.typeCode}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return null;
    }
    const props = [];
    const children = node.children;
    for (let i = 2; i < children.length; i++) {
        const candidate = children[i];
        if (candidate.type !== 'name') {
            continue;
        }
        let propTypeCode = detected.typeCode;
        for (let j = i - 1; j >= 2; j--) {
            const prev = children[j];
            if (prev.type !== 'atom') {
                break;
            }
            const c = prev.content.trim();
            if (c === '40' || c === '37') {
                propTypeCode = c;
                break;
            }
        }
        let cursor = i + 1;
        while (cursor < children.length && children[cursor].type === 'atom') {
            cursor++;
        }
        const valueNode = children[cursor];
        if (valueNode === undefined || valueNode.type !== 'value') {
            warnings.push({
                type: decoded_types_1.DecodeWarningType.InvariantViolation,
                message: `expected value node after name "${candidate.content}"`,
                severity: sigma_engine_shared_1.BoundaryLevel.Error,
                path: `${path}/props[${props.length}]`,
            });
            continue;
        }
        props.push({
            kind: 'prop',
            propTypeCode,
            name: candidate.content.trim(),
            value: valueNode.content.trim(),
            raw: candidate,
        });
        i = cursor;
    }
    if (props.length !== detected.declaredCount) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `prop-block declared count=${detected.declaredCount} but decoded ${props.length} props`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path,
        });
    }
    return {
        kind: 'prop-block',
        declaredCount: detected.declaredCount,
        props,
        raw: node,
    };
}
function findProp(block, name) {
    if (block === null) {
        return null;
    }
    for (const p of block.props) {
        if (p.name === name) {
            return p;
        }
    }
    return null;
}
function findPropValue(block, name) {
    const p = findProp(block, name);
    return p === null ? null : p.value;
}
//# sourceMappingURL=decode-prop-block.js.map